export default __webpack_public_path__ + "static/media/guide_bg_y.c5b3bfe2.png";